import withStyles from '@material-ui/core/styles/withStyles';
import React from 'react';
import green from '@material-ui/core/colors/green';
import orange from '@material-ui/core/colors/orange';
import red from '@material-ui/core/colors/red';

const styles = () => ({
  containerClass: {},
  gridLarge: {},
  searchLabel: {},
  table: {},
  checkboxCell: {
    width: '24px',
    borderBottom: '0px !important'
  },
  checkbox: {
    padding: '0'
  },
  greenText: { color: green[500] },
  orangeText: { color: orange[500] },
  redText: { color: red[500] }
});
const StatusColorDisplay = withStyles(styles)(({ status, classes }) => {
  let optionClass = '';
  const statusLookups = [
    { id: 'ACTIVE', name: 'Active' },
    { id: 'PENDING', name: 'Pending' },
    { id: 'INACTIVE', name: 'Inactive' },
    { id: 'A', name: 'Active' },
    { id: 'INVITED', name: 'Invited' },
    { id: 'OFFLINE', name: 'Offline' },
    { id: 'P', name: 'Pending' },
    { id: 'SUSPENDED', name: 'Suspended' },
    { id: 'S', name: 'Suspended' }
  ];
  const statusRenderer = statusLookups.find(
    statusChoice => status === statusChoice.id
  );
  switch (statusRenderer?.id) {
    case 'ACTIVE':
    case 'A':
      optionClass = classes.greenText;
      break;
    case 'INVITED':
    case 'INACTIVE':
    case 'PENDING':
    case 'OFFLINE':
    case 'P':
      optionClass = classes.orangeText;
      break;
    case 'SUSPENDED':
    case 'S':
      optionClass = classes.redText;
      break;
    default:
      break;
  }
  return (
    <span className={optionClass} data-testid="statusID">
      {statusRenderer?.name}
    </span>
  );
});

export default StatusColorDisplay;
